import { useEffect, useState } from "react";

let cache = null;

export const useTours = () => {
  const [tours, setTours] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    let alive = true;
    fetch("/data/tours.json")
      .then((r) => r.json())
      .then((d) => {
        cache = d;
        if (alive) setTours(d);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return tours;
};
